export default "__VITE_ASSET__0d70b1c2__"